import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-next-seminar-dates-chart',
    templateUrl: './next-seminar-dates-chart.component.html',
    styleUrl: './next-seminar-dates-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NextSeminarDatesChartComponent {

}
